import React from 'react';
import { Row, Col, Button, Typography } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';

const { Title } = Typography;

interface DashboardHeaderProps {
  onRefresh: () => void;
  loading: boolean;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({ onRefresh, loading }) => {
  return (
    <Row justify="space-between" align="middle" style={{ marginBottom: 24 }}>
      <Col>
        <Title level={2}>Request Tracking Dashboard</Title>
      </Col>
      <Col>
        <Button type="primary" icon={<ReloadOutlined />} onClick={onRefresh} loading={loading}>
          Refresh
        </Button>
      </Col>
    </Row>
  );
};

export default DashboardHeader;
